import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column email-login" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center d-flex justify-content-center" }
const _hoisted_4 = { class: "mail-icon" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = { class: "register-here" }

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import {useRoute} from "vue-router";
import LoaderContent from "@/components/LoaderContent.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import {tryOpenApp} from "@/service/appDeepLink";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyEmail',
  setup(__props) {

const state = reactive({
  error: false as boolean,
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const route = useRoute()
const notification = useNotification()

onMounted(async () => {
  loader.value?.load(async () => {
    const urlToken = route.params.token as string
    if (await tryOpenApp(`verify-email/${urlToken}`)) {
      return
    }
    try {
      const token = await api.call.token.verifyEmail(urlToken)
      notification.notify({type: 'success', title: $t('notifications.email_verified'), duration: 1500})
      await store.dispatch('authenticate', token)
      window.location.href = '/'
    } catch (e) {
      state.error = true
    }
  });
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (el) => loader.value = el
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_unref($t)('check_your_email')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SvgIcon, { icon: "mail" })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(state).error ? _unref($t)('notifications.verification_link_invalid') : _unref($t)('verifying_email')), 1)
        ]),
        (_unref(state).error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: {name:'emailLogin'} }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)('log_in')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}
}

})